import { useEffect, useState } from 'react';
import { Check, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { studioApi } from '@/lib/studioApi';
import { replaceImage } from './imageSwap';

// KI-Stile in the same tile grid as the effects: example image per style; one click paints the customer's own photo.
export const AiStyleTiles = ({ editor, o, busy }) => {
  const [styles, setStyles] = useState(null), [running, setRunning] = useState(null);
  useEffect(() => { let alive = true; Promise.all([studioApi('/ai-images/status'), studioApi('/quickstart')]).then(([s, c]) => alive && setStyles(s.enabled ? c.styles : [])).catch(() => alive && setStyles([])); return () => { alive = false; }; }, []);
  if (!styles?.length || !o.assetId || o.stockId) return null;
  const run = async s => {
    setRunning(s.id);
    try {
      const r = await studioApi('/quickstart/generate', { method: 'POST', body: { asset_id: o.assetId, style_id: s.id } });
      replaceImage(editor, o, r, { name: s.name, aiGenerated: true, effect: 'none' });
      toast.success(`${s.name} ist fertig.`, { description: 'Gefällt es dir nicht? Mit „Rückgängig“ kommst du zurück zu deinem Foto.' });
    } catch (e) { toast.error(e.message); } finally { setRunning(null); }
  };
  return <><p className="effect-group-title">KI-Stile <small>malt dein Foto neu · ca. 30–60 Sek.</small></p>
    <div className="effect-grid is-color" role="group" aria-label="KI-Stile" data-testid="ai-style-tiles">{styles.map(s => <button key={s.id} type="button" className={`effect-tile ${o.name === s.name ? 'active' : ''}`} disabled={!!running || busy || o.locked} onClick={() => run(s)} data-testid={`ai-style-${s.id}`}>
      <span className="effect-thumb"><img src={s.example} alt="" />{running === s.id && <Loader2 size={16} className="spin effect-busy" />}{o.name === s.name && !running && <Check size={12} className="effect-check" />}</span>
      <strong>{s.name}</strong><small>{running === s.id ? 'wird gemalt …' : 'Beispiel'}</small></button>)}</div></>;
};
